import { ButtonGroup } from "reactstrap";
import { Label } from "reactstrap";
import { TEMP_SETTING_OPTION } from "../../../globals/interfaces";
import { Button } from "reactstrap";

export default function TempControlPicker({
    filterTempSetting,
    setFilterTempSetting
}: {
    filterTempSetting: string;
    setFilterTempSetting: React.Dispatch<React.SetStateAction<string>>;
}) {
    return (
        <div>
            <Label className={'mr-2'}>Temp Control Settings:</Label>
            <ButtonGroup>
                {
                    TEMP_SETTING_OPTION.map((item, i) => (
                        <Button
                            active={item === filterTempSetting}
                            onClick={() => setFilterTempSetting(item)}
                            key={i}
                        >
                            {item}
                        </Button>
                    ))
                }
            </ButtonGroup>
        </div>
    );
}